import { BrowserType } from '@/constants/browserTypes';
import { CheckoutRedirectOrderStatus } from '@/constants/checkoutRedirectOrderStatus';
import { FeatureFlag } from '@/constants/featureFlags';
import type { OrderResponse } from '@/types/order';
import { getQueryParam } from './queryParams';

export const SUPPORTED_BROWSERS_FOR_AUTO_REDIRECT = [BrowserType.TWA, BrowserType.CCT, BrowserType.SFSVC];

export const isAutoRedirectSupported = () => {
  const browserType = getQueryParam('browserType');
  return SUPPORTED_BROWSERS_FOR_AUTO_REDIRECT.includes(browserType as BrowserType);
};

export const shouldRedirectUser = (featureFlags: Record<FeatureFlag, boolean>) => {
  return featureFlags[FeatureFlag.CHECKOUT_SHOW_BACK_TO_GAME_BUTTON] && isAutoRedirectSupported();
};

export const buildRedirectLink = (
  redirectLink: string,
  orderData?: OrderResponse | null,
  orderId?: string,
  status: CheckoutRedirectOrderStatus = CheckoutRedirectOrderStatus.SUCCESS
) => {
  const separator = redirectLink.includes('?') ? '&' : '?';
  const purchaseIdParam = orderData?.publisherPurchaseId ? `&purchaseId=${orderData?.publisherPurchaseId}` : '';
  const orderIdParam = orderId ? `&orderId=${orderId}` : '';
  return `${redirectLink}${separator}status=${status}${orderIdParam}${purchaseIdParam}`;
};
